// utils/sdsPublic.js
// SDS-Admin 公开端点（无鉴权、跨域）统一访问层。
// 前台直接 GET https://zhongzhuan.xinlian88.tech/api/v1/public/project/nvivoai/<resource>
// 响应统一为 { code: 0, data: {...} }；失败/非 0 返回 null，调用方各自回退默认。
// 资源：membership_intro（会员弹窗介绍）/ agreements（协议）/ wechat_qrcodes（企微二维码）。

export const WXZZ_PUBLIC_BASE = 'https://zhongzhuan.xinlian88.tech/api/v1/public'
export const SDS_PROJECT_KEY = 'nvivoai'

export async function fetchSdsPublic(resource) {
  try {
    const resp = await fetch(`${WXZZ_PUBLIC_BASE}/project/${SDS_PROJECT_KEY}/${resource}`, {
      credentials: 'omit',
    })
    if (resp.ok) {
      const body = await resp.json()
      if (body && body.code === 0) return body.data
    }
  } catch (e) {
    console.warn('[sdsPublic]', resource, 'fetch failed:', e)
  }
  return null
}
